<template>
  <ion-page>
    <ion-content :fullscreen="false" color="light" class="ion-padding">
      <ion-grid style="height: 100%">
        <ion-row class="ion-align-items-center" style="min-height: 20%">
          <ion-col class="ion-text-center">
            <img
              width="25%" alt="" :src="`/images/customer_logos/${branding.logo}`"
              data-testid="login-page-logo"
            >
            <h1>{{ branding.name }}</h1>
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center" style="min-height: 20%">
          <ion-card style="width: 100%" class="ion-no-margin ion-margin-top ion-margin-bottom">
            <ion-card-header mode="md">
              <ion-card-title>Book a Golf Lesson</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col>
                    <ion-button
                      expand="block" fill="outline"
                      style="--border-color: var(--sm-color-edmonton); color: var(--sm-color-edmonton);"
                      :router-link="{name: 'guestNewLesson'}"
                    >
                      Find a Golf Instructor
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-row>
        <ion-row v-if="branding.name === 'SwingMatch Golf'" class="ion-align-items-center" style="min-height: 25%">
          <ion-card style="width: 100%" class="ion-no-margin">
            <ion-card-header mode="md">
              <ion-card-title>Manage Your Instruction Business</ion-card-title>
              <!-- <ion-card-subtitle>
                1) Create Your Profile
                <br>
                2) Add Availability
                <br>
                3) Teach your Game!
              </ion-card-subtitle> -->
            </ion-card-header>
            <ion-card-content>
              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col>
                    <ion-button
                      expand="block" color="primary" fill="outline"
                      @click="handleInstructorSignUp"
                    >
                      Sign Up as a Golf Instructor
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script setup>
import {
  IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol,
  IonContent, IonGrid, IonPage, IonRow,
} from '@ionic/vue'
import { useRouter } from 'vue-router'

import { redirectToNewAppAuth, shouldUseNewAppAuth } from '@/config/legacy-domain-policy'
import { branding } from '@/globals'

const router = useRouter()

function handleInstructorSignUp() {
  if (shouldUseNewAppAuth()) {
    redirectToNewAppAuth()
    return
  }

  router.push({ query: { show: 'login', mode: 'signup' }})
}
</script>
